import React from 'react';
import PastBlastList from '../blast_sms/PastBlastList';

function EmailBlast() {
    return (
        <PastBlastList
            title="Past Email Blast"
            description="Track email blasts from creation through send completion."
            icon="bi-send"
            type="EMAIL"
            createPath="/blast/create-email"
            createLabel="Create Email Blast"
            resultsBasePath="/blast/email"
            emptyTitle="No email blasts yet"
            emptyDescription="Create an email blast to message selected patients. Past launches will show here with status."
            infoText="Only patients with an email address who have not opted out of email are eligible for email blasts. While Pending, you can Stop a blast before it sends. Use Results after a blast completes or errors."
        />
    );
}

export default EmailBlast;
